import { IVersionedFile } from "./versioned-file";

export interface ILegalDocumentsData {
    centerContract: IVersionedFile;
    centerAllInAgreemnet: IVersionedFile;
    donorProtectionProgramAddendum: IVersionedFile;
    recipientCenterAgreement: IVersionedFile;
    donorCenterAgreement: IVersionedFile;
    baa: IVersionedFile;
    partnerAgreement: IVersionedFile;
    dcnAgreement: IVersionedFile;
    donorShieldAgreement: IVersionedFile;
}